import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ChangeRecord from '../../components/ChangeRecord';
import { connect } from 'react-redux';
import { fetchEffectiveData } from './reducers/effectiveDataReducer';
import { fetchChangeRecords, addChangeRecord, removeChangeRecord } from './reducers/changeRecordsReducer';
import InfoView from './components/InfoView';
import ViewDataItem from '../../components/ViewDataItem';
import NewRecordApplyForm, { fields as formFields, formName } from './components/NewRecordApplyForm';
import { initialize } from 'redux-form';
import { pascalizeKeys } from 'humps';
import { find } from 'lodash';
import { FormattedMessage } from 'react-intl';
import Loading from 'components/Loading';

class BasicInfo extends Component {
  constructor() {
    super();
    this.state = {
      showForm: false,
      isInitialized: false,
    };
    this.onClickApplyButton = this.onClickApplyButton.bind(this);
    this.onCloseFormClick = this.onCloseFormClick.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    Promise.all([
      this.props.fetchEffectiveData(),
      this.props.fetchChangeRecords(),
    ]).then(() => this.setState({ isInitialized: true }), () => this.setState({ isInitialized: true }));
  }

  onClickApplyButton() {
    this.props.initialize(formName, this.props.effectiveData.data, formFields);
    this.setState({
      showForm: true,
    });
  }

  onCloseFormClick(event) {
    event.preventDefault();
    this.setState({
      showForm: false,
    });
  }

  onFormSubmit(value) {
    const formData = new FormData();
    formData.append('attachFile', value.attachFile);
    delete value.attachFile;
    value.action = 'PUT';
    formData.append('Data', JSON.stringify(pascalizeKeys(value)));
    return this.props.addChangeRecord(formData).then(() => {
      this.props.fetchChangeRecords();
      this.setState({
        showForm: false,
      });
      return Promise.resolve();
    }, (json) => {
      return Promise.reject({ _error: json.message });
    });
  }

  renderViewItems() {
    const { effectiveData, fieldSettings, changeRecords } = this.props;

    if (effectiveData.data === null || fieldSettings.data === null || !changeRecords.isLoaded) {
      return '';
    }
    const allowEdit = find(changeRecords.data, (data) => {
      return data.currentStatus === '40' || data.currentStatus === '10';
    }) === undefined;


    return (
      <div className="tab-body clearfix">
        <button className="btn action" onClick={this.onClickApplyButton} disabled={!allowEdit}>
          <i className="glyphicon glyphicon-pencil"></i>
        </button>
        <InfoView basicInfo={effectiveData.data} fieldSettings={fieldSettings.data}/>
      </div>
    );
  }

  renderChangeRecords() {
    const { changeRecords, fieldSettings } = this.props;

    if (!changeRecords.data || !fieldSettings.data) {
      return '';
    }

    return (
      <div className="change-record-container">
        {
          changeRecords.data.map((record) => {
            const recordId = record.id;
            return (
              <ChangeRecord
                date={record.createOn}
                status={record.currentStatus}
                rejectReason={record.backReasons}
                key={record.id}
                onDelete={
                  (event) => {
                    event.preventDefault();
                    this.props.removeChangeRecord(recordId);
                  }
                }
              >
                <InfoView basicInfo={record} fieldSettings={fieldSettings.data}>
                  <hr />
                  <ViewDataItem label={[<FormattedMessage key="1" id="SH_ModifyReason" defaultMessage="修改原因"/>]} text={record.reasons}/>
                  <ViewDataItem label={[<FormattedMessage key="1" id="SH_SupportingDocuments" defaultMessage="證明文件"/>]} text={record.displayFilename}/>
                </InfoView>
              </ChangeRecord>
            );
          })
        }
      </div>
    );
  }

  render() {
    const { isInitialized } = this.state;
    const {
      params,
      fieldSettings,
    } = this.props;

    if (!isInitialized) {
      return <Loading small/>;
    }
    return (
      <div>
        {
          this.state.showForm && params.isLoaded && fieldSettings.isLoaded && (
            <NewRecordApplyForm
              onSubmit={this.onFormSubmit}
              genders={params.data.Sex}
              arms={params.data.Arms}
              nationality={params.data.Nationality}
              militaryService={params.data.MilitaryService}
              maritalStatusOptions={params.data.MaritalStatus}
              iDTypes={params.data.IDType}
              fieldSettings={fieldSettings.data}
              onClose={this.onCloseFormClick}
            />
          )
        }
        {this.renderViewItems()}
        {this.renderChangeRecords()}
      </div>
    );
  }
}

BasicInfo.propTypes = {
  fetchEffectiveData: PropTypes.func.isRequired,
  effectiveData: PropTypes.object.isRequired,
  fetchChangeRecords: PropTypes.func.isRequired,
  changeRecords: PropTypes.object.isRequired,
  fieldSettings: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  initialize: PropTypes.func.isRequired,
  addChangeRecord: PropTypes.func.isRequired,
  removeChangeRecord: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    effectiveData: state.app.foundation.mydata.basicInfo.effectiveData,
    changeRecords: state.app.foundation.mydata.basicInfo.changeRecords,
    fieldSettings: state.app.foundation.mydata.fieldSettings,
    params: state.app.foundation.mydata.params,
  };
}

export default connect(mapStateToProps, {
  fetchEffectiveData,
  fetchChangeRecords,
  initialize,
  addChangeRecord,
  removeChangeRecord,
})(BasicInfo);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/screens/BasicInfo/index.js
 **/